import React, { Component } from "react";
import { Row, Col, Card, Table } from "reactstrap";
import CgnAlert from "../toolbox/CgnAlert";
import CgnLoader from "../toolbox/CgnLoader";
import CgnButtonLink from "../toolbox/CgnButtonLink";
import ContentTop from "../root/ContentTop";
import axios from "axios";
import {  URL } from "../../redux/actions/constants";
import moment from "moment";

class CompanyUserGroupDetail extends Component {
  state = {
    pageTitle: "Firma Personel Grup Detay",
    pageTitleDetail: "Firma Personel Grup Detay",
    pageAddLink: "firma-personel-grup-ekle",
    pageListLink: "firma-personel-grup-listele",
    breadcrumb: [{ text: "Firma Personel Grupları", link: "#" }],
    isLoading: false,
    alertErrorMessage: "",
    name: "",
    status: "",
    userGroupAuthorization: "",
    createdByA: "",
    createdAt: "",
    updatedAt: "",
    updatedByA: "",
  };

  async componentDidMount() {
    let urlSplit = window.location.pathname.split("/");
    if (urlSplit.length === 3) {
      this.setState({
        pageTitle: this.state.pageTitleDetail,
        isLoading: true,
      });
      // 
      var config = {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      };
      axios
        .get(URL + "/groups/get/" + urlSplit[2], config)
        .then((response) => {
          this.setState({
            name: response.data.name,
            status: response.data.status,
            createdByA: response.data.createdByA,
            createdAt: moment(response.data.createdAt).format(
              "DD/MM/YYYY HH:mm"
            ),
            updatedByA: response.data.updatedByA,
            updatedAt: moment(response.data.updatedAt).format(
              "DD/MM/YYYY HH:mm"
            ),
            isLoading: false,
          });
        })
        .catch((error) => {
          this.setState({
            alertErrorMessage: error.response.data,
            isLoading: false,
          });
        });
    }
  }

  render() {
    return (
      <>
        <ContentTop
          breadcrumb={this.state.breadcrumb}
          title={this.state.pageTitle}
          addLink={"/" + this.state.pageAddLink}
          listLink={"/" + this.state.pageListLink}
        />
        <Row>
          <Col>
            <Card body className="table-responsive">
              <CgnLoader visibled={this.state.isLoading} />
              {this.state.alertErrorMessage && (
                <CgnAlert
                  color="danger"
                  title="Uyarı"
                  text={this.state.alertErrorMessage}
                />
              )}
              <Table className="table table-responsive table-hover">
                <tbody>
                  <tr>
                    <th>Firma Personel Grubu</th>
                    <td colSpan="4">
                      {this.state.name ? this.state.name : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Firma Personel Grup Yetkileri</th>
                    <td colSpan="4">
                      {this.state.userGroupAuthorization
                        ? this.state.userGroupAuthorization
                        : "-"}
                    </td>
                  </tr>
                  <tr>
                    <th>Durum</th>
                    <td colSpan="4">{this.state.status ? "Aktif" : "Pasif"}</td>
                  </tr>
                  <tr>
                    <th>Kaydeden Kullanıcı</th>
                    <td>
                      {this.state.createdByA ? this.state.createdByA : "-"}
                    </td>
                    <th>Kaydedilme Tarihi</th>
                    <td>{this.state.createdAt ? this.state.createdAt : "-"}</td>
                  </tr>
                  <tr>
                    <th>Son Güncelleyen Kullanıcı</th>
                    <td>
                      {this.state.updatedByA ? this.state.updatedByA : "-"}
                    </td>
                    <th>Son Güncellenme Tarihi</th>
                    <td>{this.state.updatedAt ? this.state.updatedAt : "-"}</td>
                  </tr>
                </tbody>
              </Table>
            </Card>
            <CgnButtonLink
              color="secondary"
              to={"/" + this.state.pageListLink}
              text="Geri"
              className="btn-back"
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default CompanyUserGroupDetail;
